interface FlowStep {
  label: string;
  detail: string;
}

interface FlowStepsProps {
  steps: FlowStep[];
}

// Vertical stack with mono arrow connectors — used for "how the pieces
// connect" style diagrams (client stack → NOVTIA layer → outcomes).
const FlowSteps = ({ steps }: FlowStepsProps) => {
  return (
    <div className="max-w-2xl mx-auto">
      {steps.map((step, i) => (
        <div key={step.label}>
          <div className="surface-card px-5 py-4 text-center">
            <p className="kicker justify-center mb-1.5">{step.label}</p>
            <p className="text-sm text-ink">{step.detail}</p>
          </div>
          {i < steps.length - 1 && (
            <div className="font-mono text-center text-line-strong py-1.5" aria-hidden="true">
              ↓
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FlowSteps;
